var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 14.667L1.3335 14.667",
    stroke: "#2058E7",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 14.6663V3.99967C11.3332 2.7426 11.3332 2.11406 10.9426 1.72353C10.5521 1.33301 9.92358 1.33301 8.6665 1.33301H7.33317C6.07609 1.33301 5.44755 1.33301 5.05703 1.72353C4.6665 2.11406 4.6665 2.7426 4.6665 3.99967V14.6663",
    stroke: "#2058E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 14.6663V7.66634C13.9998 6.73003 13.9998 6.26188 13.7751 5.92558C13.6779 5.77999 13.5529 5.65499 13.4073 5.55771C13.071 5.33301 12.6028 5.33301 11.6665 5.33301",
    stroke: "#2058E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6663V7.66634C2 6.73003 2 6.26188 2.22471 5.92558C2.32199 5.77999 2.44699 5.65499 2.59257 5.55771C2.92887 5.33301 3.39703 5.33301 4.33333 5.33301",
    stroke: "#2058E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.667V12.667",
    stroke: "#2058E7",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 3.33301H9.33317",
    stroke: "#2058E7",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 5.33301H9.33317",
    stroke: "#2058E7",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 7.33301H9.33317",
    stroke: "#2058E7",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 9.33301H9.33317",
    stroke: "#2058E7",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeIcon);
export default __webpack_public_path__ + "static/media/OfficeIcon.63fc026abb6e58d13097d4615f15c0f7.svg";
export { ForwardRef as ReactComponent };